export default __webpack_public_path__ + "static/media/three.9c073586.jpg";